import styled from 'styled-components';

// import { COLORS } from '../../utils/styles/Constants';

export const FooterWrapper = styled.footer`
    height: 5em;
    .site-footer:hover{
        color: red;
    }
`;